import React,{ createContext, useContext,useEffect,useState } from "react";
import { getReferalDetail } from "../actions/ReferralAction";
import { getCashWinnertxCashPrizeeligible } from "../actions/StudentAction";

const stateContext = createContext();

export const StateContextProvider = ({children}) => {
    const [userDetail,setUserDetail] = useState([]);
    const [countryCode,setCountryCode] = useState(undefined);
    const [feeDetail,setFeeDetail] = useState([]);
    const [feeLoader,setFeeLoader] = useState(true)
    const [PageLoader,setPageLoader] = useState(true);
    const [referalDataList,setReferalDataList] = useState([]);
    const [referalDetailLoader,setReferalDetailLoader] = useState(true)
    const [txCashWinnerEligible,setTxCashWinnerEligible] = useState(false)

    const fetchReferalDetail = async() => {
        setReferalDetailLoader(true)
        try {
            await getReferalDetail().then((res) => {
                if(res.status){
                    setReferalDataList(res?.data)
                    setReferalDetailLoader(false)
                } 
            })
        } catch (error) {  
            console.log('referal list...',error)
        }
    }

    const fetchTxCashWinnerEligible = async(userFno) => {
        try {
            await getCashWinnertxCashPrizeeligible(userFno).then((res) => {
                if(res.status){
                    setTxCashWinnerEligible(res)
                } 
            })
        } catch (error) {  
            console.log('txCashWinnerEligible...',error)
        }
    }

    useEffect(() => {
            fetchReferalDetail()
            // fetchTxCashWinnerEligible(userDetail?.form_num)
    },[])

    return(
        <stateContext.Provider value={{PageLoader,setPageLoader,userDetail,setUserDetail,countryCode,setCountryCode,feeDetail,setFeeDetail,feeLoader,setFeeLoader,referalDataList,setReferalDataList,fetchReferalDetail,referalDetailLoader,txCashWinnerEligible,fetchTxCashWinnerEligible}}>
            {children}
        </stateContext.Provider>
    )
}

export const StateUseContext = () => useContext(stateContext)